import { ReactNode } from 'react';

import styles from './FormError.module.scss';

export const FormError = ({ children }: { children: ReactNode }) => {
    if (!children) {
        return null;
    }
    return <div className={styles.error}>{children}</div>;
};
